<div class="personal-data-container component-container subscriber-container">
  <form [formGroup]="subscriberDataFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
    <div class="ui-g form-rows" *ngIf="!addParcelAddress">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows checkbox-row">
        <label class="ui-g-5 checkbox-width"></label>
        <p-checkbox
          appEnterClick
          (onChange)="useSameAddressAsConnection($event)"
          binary="true"
          formControlName="infoCheckbox"
          id="personal-data-info-check"
          [readonly]="isReadOnly"
          label="{{ 'personal-data.form-details.fields.info-checkbox' | translate }}"></p-checkbox>
      </div>
      <div *ngIf="showMessageForAddress" class="ui-g-6 field-rows">
        {{ 'personal-data.copy-data-message' | translate }}
      </div>
    </div>
    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="personal-data-title">
          {{ 'personal-data.form-details.fields.title' | translate }}
        </label>
        <p-dropdown [options]="allTitles" formControlName="title" id="personal-data-title" placeholder="-Select-" [readonly]="isReadOnly">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align" for="personal-data-company">
          {{ 'personal-data.form-details.fields.company' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="company"
          id="personal-data-company"
          pInputText
          size="30"
          maxlength="50"
          type="text"
          [readonly]="isReadOnly" />
      </div>
      <!-- <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align required"
               for="personal-data-customer-no">{{'personal-data.form-details.fields.customer-number' | translate}}</label>
        <input class="ui-input pInputText" formControlName="customerNo" id="personal-data-customer-no"
               pInputText
               size="30" type="text">
      </div> -->
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="personal-data-fname">
          {{ 'personal-data.form-details.fields.first-name' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="firstName"
          id="personal-data-fname"
          pInputText
          size="30"
          maxlength="50"
          type="text"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align required" for="personal-data-lname">
          {{ 'personal-data.form-details.fields.last-name' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="lastName"
          id="personal-data-lname"
          pInputText
          size="30"
          maxlength="50"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="personal-data-street">
          {{ 'personal-data.form-details.fields.street' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="street"
          id="personal-data-street"
          pInputText
          size="30"
          maxlength="30"
          appAlpha="true"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align required" for="personal-data-street-no">
          {{ 'personal-data.form-details.fields.street-number' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="streetNo"
          id="personal-data-street-no"
          pInputText
          size="30"
          maxlength="10"
          appStreetNumber="true"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align" for="personal-data-address-suffix">
          {{ 'personal-data.form-details.fields.address-suffix' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="addressSuffix"
          id="personal-data-address-suffix"
          pInputText
          size="30"
          type="text"
          [readonly]="isReadOnly" />
      </div>

      <div
        class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding"
        *ngIf="
          currentInstallationFlow === installationFlowType.MainsConnection ||
          currentInstallationFlow === installationFlowType.FeedInSystem ||
          currentInstallationFlow === installationFlowType.TemporaryConnection ||
          currentInstallationFlow === installationFlowType.ChangeHouseConnection
        ">
        <label class="ui-g-5 field-label text-right-align required" for="personal-data-land">
          {{ 'personal-data.form-details.fields.land' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="land"
          id="personal-data-land"
          pInputText
          size="30"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="personal-data-city">
          {{ 'personal-data.form-details.fields.city' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="city"
          id="personal-data-city"
          pInputText
          size="30"
          maxlength="100"
          type="text"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align required" for="personal-data-postcode">
          {{ 'personal-data.form-details.fields.post-code' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="postCode"
          id="personal-data-postcode"
          pInputText
          size="30"
          [appNumber]="true"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align" [class.required]="telephoneEmailRequired" for="personal-data-telephone">
          {{ 'personal-data.form-details.fields.telephone' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="telephone"
          id="personal-data-telephone"
          pInputText
          size="30"
          maxlength="50"
          [appNumber]="true"
          [readonly]="isReadOnly" />
      </div>

      <div *ngIf="subscriberDataFG.get('mobile')" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <label class="ui-g-5 field-label text-right-align" for="personal-data-mobile">
          {{ 'personal-data.form-details.fields.mobile' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="mobile"
          id="personal-data-mobile"
          pInputText
          size="30"
          maxlength="50"
          [appNumber]="true"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align" [class.required]="telephoneEmailRequired" for="personal-data-email">
          {{ 'personal-data.form-details.fields.email' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="email"
          id="personal-data-email"
          pInputText
          size="30"
          maxlength="200"
          type="text"
          [readonly]="isReadOnly" />
      </div>
      <button
        *ngIf="showResendOwnerEmailBtn"
        (click)="resendOwnerEmail()"
        id="resend-email-btn"
        [label]="'personal-data.form-details.fields.resend-email' | translate"
        [disabled]="disableResendOwnerEmailBtn"
        pButton
        type="button"></button>
    </div>

    <div class="ui-g form-rows" *ngIf="!isReadOnly">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label
          class="ui-g-5 field-label text-right-align"
          [class.required]="telephoneEmailRequired || repeatEmailRequired"
          for="personal-data-repeat-email">
          {{ 'personal-data.form-details.fields.repeat-email' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="repeatEmail"
          id="personal-data-repeat-email"
          pInputText
          size="30"
          maxlength="200"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g form-rows" *ngIf="this.showLandownerSwitch || this.showInvoiceRecepientSwitch">
      <div *ngIf="this.showLandownerSwitch" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align" for="personal-data-landowner">
          {{ 'personal-data.form-details.fields.land-owner' | translate }}
        </label>
        <p-inputSwitch
          appEnterClick
          formControlName="landowner"
          id="personal-data-landowner"
          [readonly]="isReadOnly"
          (click)="handleLandownerDocumentSection()"></p-inputSwitch>
      </div>

      <div *ngIf="this.showInvoiceRecepientSwitch" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-5 field-label text-right-align" for="personal-data-invoice-recipient">
          {{ 'personal-data.form-details.fields.invoice-recipient' | translate }}
        </label>
        <p-inputSwitch
          appEnterClick
          formControlName="invoiceRecipient"
          id="personal-data-invoice-recipient"
          [readonly]="isReadOnly"></p-inputSwitch>
      </div>

      <div class="ui-g-12 form-rows form-background landowner-document-row" *ngIf="subscriberDataFG.get('landownerDocumentName')">
        <div class="ui-g-12 field-rows landowner-document-upload-section section-field">
          <label class="ui-g-3 field-label text-right-align required">
            {{ 'personal-data.form-details.fields.license-agreement' | translate }}
          </label>
          <app-file-upload
            class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
            [fileData]="landownerDocument"
            [inputName]="'landownerDocument'"
            [isDetailsView]="isReadOnly"
            [isClearButtonDisabled]="isReadOnly"
            [type]="documentTypes.PowerOfAttorney"
            [isRequired]="!isReadOnly"
            (clearFileEvent)="deleteDocument($event.documentId)"
            (fileDataChangeEvent)="updateFile($event)"></app-file-upload>
        </div>
      </div>
    </div>
    <div *ngIf="showLandownerWarning" class="ordnance-warning">
      <i class="pi pi-exclamation-circle info-icon"></i>
      <span [innerHTML]="'personal-data.landowner-text-message' | translate"></span>
    </div>

    <app-review-section
      #connectionUserSection
      *ngIf="showConnectionUser"
      [title]="'personal-data.form-details.connection-user-title' | translate"
      [tooltip]="'tooltips.personal-data.connection-user' | translate"
      [sectionId]="ConnectionUserSectionIdentifier"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView"
      [showButtonsPredicate]="hideButtonsForChimneySweeper">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="connection-user-fname">
              {{ 'personal-data.form-details.fields.first-name' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="con_user_firstname"
              id="connection-user-fname"
              pInputText
              size="30"
              maxlength="50"
              type="text"
              [readonly]="!connectionUserSection.isDataEditable" />
          </div>

          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
            <label class="ui-g-5 field-label text-right-align" for="connection-user-lname">
              {{ 'personal-data.form-details.fields.last-name' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="con_user_lastname"
              id="connection-user-lname"
              pInputText
              size="30"
              maxlength="50"
              type="text"
              [readonly]="!connectionUserSection.isDataEditable" />
          </div>
        </div>
        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="connection-user-telephone">
              {{ 'personal-data.form-details.fields.telephone' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              formControlName="con_user_phone"
              id="connection-user-telephone"
              pInputText
              size="30"
              maxlength="50"
              [appNumber]="true"
              [readonly]="!connectionUserSection.isDataEditable" />
          </div>
        </div>
      </div>
    </app-review-section>
  </form>
</div>
